interface BrandMarkProps {
  variant?: 'lockup-dark' | 'lockup-light' | 'symbol-light' | 'symbol-dark' | 'wordmark';
  className?: string;
  /** Show tagline under wordmark (marketing only). */
  showTagline?: boolean;
}

/** Approved MyLighthouse brand mark. Prefer SVG lockups/symbols; wordmark for text chrome. */
export function BrandMark({
  variant = 'wordmark',
  className = '',
  showTagline = false,
}: BrandMarkProps) {
  if (variant === 'lockup-dark') {
    return (
      <img
        src="/brand/mylighthouse-lockup-dark.svg"
        alt="MyLighthouse — Find your way forward."
        className={`h-10 w-auto object-contain sm:h-11 ${className}`}
      />
    );
  }

  if (variant === 'lockup-light') {
    return (
      <img
        src="/brand/mylighthouse-lockup-light.svg"
        alt="MyLighthouse — Find your way forward."
        className={`h-10 w-auto object-contain sm:h-11 ${className}`}
      />
    );
  }

  if (variant === 'symbol-light') {
    return (
      <img
        src="/brand/mylighthouse-symbol-light.svg"
        alt=""
        aria-hidden
        className={`h-9 w-auto object-contain ${className}`}
      />
    );
  }

  if (variant === 'symbol-dark') {
    return (
      <img
        src="/brand/mylighthouse-symbol-dark.svg"
        alt=""
        aria-hidden
        className={`h-9 w-auto object-contain ${className}`}
      />
    );
  }

  return (
    <span className={`inline-flex flex-col leading-none ${className}`}>
      <span className="font-display text-xl font-bold tracking-tight sm:text-[1.35rem]">
        <span className="text-[var(--color-midnight)]">My</span>
        <span className="text-[var(--color-brand-primary)]">Lighthouse</span>
      </span>
      {showTagline ? (
        <span className="mt-1 text-[11px] font-medium italic text-[var(--color-text-muted)]">
          Find your way forward.
        </span>
      ) : null}
    </span>
  );
}
